/**
 * LanguageSelector Component
 * 
 * A dropdown for selecting transcription language.
 */

import React from 'react';
import LanguageIcon from '@mui/icons-material/Language';
import './LanguageSelector.css';

export interface Language {
  value: string;
  label: string;
}

export interface LanguageSelectorProps {
  value: string;
  onChange: (language: string) => void;
  languages?: Language[];
  disabled?: boolean;
  variant?: 'positive' | 'negative' | 'neutral' | 'purple' | 'warning';
  label?: string;
}

const DEFAULT_LANGUAGES: Language[] = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'it', label: 'Italian' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'nl', label: 'Dutch' },
  { value: 'ru', label: 'Russian' },
  { value: 'zh', label: 'Chinese' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ko', label: 'Korean' },
  { value: 'ar', label: 'Arabic' },
  { value: 'hi', label: 'Hindi' },
];

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  value,
  onChange,
  languages = DEFAULT_LANGUAGES,
  disabled = false,
  variant = 'neutral',
  label,
}) => {
  return (
    <div className={`language-selector-wrapper ${variant}`}>
      {label && <label className="language-selector-label">{label}</label>}
      <div className={`language-selector ${variant} ${disabled ? 'disabled' : ''}`}>
        <LanguageIcon className="language-icon" />
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className="language-select"
        >
          {languages.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LanguageSelector;
